import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Texas">
                <h1>
                  Top Leading Mobile App Development Company in Texas, USA
                </h1>
              </div>
              <p className="main_para">
                Are you ready to revolutionize your business to new heights with
                our mobile app development in Texas? The search is over. You can
                now revolutionize your mobile applications with our experienced
                team of app developers in Texas , project managers, technical
                business analysts, and QA professionals for scalable solutions.
                TekRevol’s mobile app development team in Texas has a reputation
                for turning epic ideas into premium, high-end, user-centric
                mobile applications
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                {" "}
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
